module.exports = __webpack_public_path__ + "img/icon_rotate_left.2d8a8df8.png";